import React, { useState, useEffect } from "react";
import ColorFieldComponent from "../../../Components/Forms/ColorFieldComponent";
import ImageUploadComponent from "../../../Components/Forms/ImageUploadComponent";
import { ConeLogisticoConfiguracao } from "../../../Models/Paineis/ConeLogistico/ConeLogisticoConfiguracao";
import { ReactComponent as Programadas } from "../../../Svgs/ConeLogistico/topo_programadas.svg";
import { ReactComponent as EmViagem } from "../../../Svgs/ConeLogistico/topo_em_viagem.svg";
import { ReactComponent as Finalizadas } from "../../../Svgs/ConeLogistico/topo_finalizadas.svg";

const ConeLogisticoConfiguracaoFundoTab = (props: any) => {
    const [coneLogisticoConfiguracao, setConeConfiguracao] = useState<any>(new ConeLogisticoConfiguracao());

    useEffect(() => {
        setConeConfiguracao(props.coneLogisticoConfiguracao);
    }, [props.coneLogisticoConfiguracao]);

    return (
        <div>
            <div className="row">
                <div className="col-md-2 mb-2">
                    <ImageUploadComponent
                        label="Logotipo"
                        field='logotipo'
                        uploadedField='file_to_upload'
                        default='KronaMaxxiReduzida.png'
                        model={coneLogisticoConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Fundo"
                        field='cor_fundo'
                        type='background-color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneLogisticoConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor cabeçalho"
                        field='cor_cabecalho'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneLogisticoConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Fonte Cabeçalho"
                        field='cor_fonte_cabecalho'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneLogisticoConfiguracao}
                    />
                </div>
                <div className="col-md-2 mb-2">
                    <ColorFieldComponent
                        label="Cor Fonte Título"
                        field='cor_fonte_titulo'
                        type='color'
                        colorChangedCallback={props.colorChangedCallback}  
                        model={coneLogisticoConfiguracao}
                    />
                </div>
            </div>

            <div className="row area_cor_fundo">
                <div className="col-md-4 mb-4">
                    <Programadas />
                </div>
                <div className="col-md-4 mb-4">
                    <EmViagem />
                </div>
                <div className="col-md-4 mb-4">
                    <Finalizadas />
                </div>

                <h4 className="col-md-12"><strong className="chart-title area_cor_fonte_titulo">Gerenciamento de Risco Logístico</strong></h4>
            </div>
        </div>
    );
}

export default ConeLogisticoConfiguracaoFundoTab;